import { Link } from "react-router-dom";
import { BRAND } from "@/lib/assets";

const groups = [
  {
    title: "Producto",
    links: [
      { label: "Cobro recurrente", href: "#features" },
      { label: "Checkout temeable", href: "#features" },
      { label: "Adquirentes DR", href: "#features" },
      { label: "Precio", href: "#pricing" },
    ],
  },
  {
    title: "Empresa",
    links: [
      { label: "Sobre Kubo", href: BRAND.ctaUrl },
      { label: "Contacto", href: "mailto:hola@kubopayments.com" },
      { label: "Solicitar demo", href: "/demo", internal: true },
      { label: "Preguntas", href: "#faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Términos", href: "/terminos", internal: true },
      { label: "Privacidad", href: "/privacidad", internal: true },
      { label: "Devoluciones", href: "/devoluciones", internal: true },
      { label: "Seguridad", href: "/seguridad", internal: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="landing-footer"
      className="bg-[#111111] text-white/80"
    >
      <div className="max-w-8xl mx-auto px-5 sm:px-8 py-20 grid grid-cols-2 md:grid-cols-12 gap-10 md:gap-12">
        <div className="col-span-2 md:col-span-5">
          <div className="flex items-center gap-2.5">
            <img
              src={BRAND.logo}
              alt="Kubo Payments"
              className="h-8 w-auto brightness-0 invert"
            />
            <span className="font-['Cabinet_Grotesk'] font-black text-white tracking-tight text-lg">
              Kubo Payments
            </span>
          </div>
          <p className="mt-5 text-base leading-relaxed max-w-sm text-white/70">
            CRM de cobros hecho para República Dominicana. Cobra tus membresías
            en automático, recupera pagos fallidos solo, y crece sin perseguir.
          </p>
          <div className="mt-8 flex flex-col gap-3">
            <span className="text-base font-bold uppercase tracking-[0.18em] text-[#111111]">
              Hecho en RD
            </span>
            <span className="w-8 h-px bg-white/20" />
            <span className="text-sm text-white/65">Santo Domingo</span>
            <a
              href="https://wa.me/18299278886"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white/70 hover:text-[#a68a6d] transition-colors"
              data-testid="footer-whatsapp"
            >
              Soporte por WhatsApp: +1 (829) 927‑8886
            </a>
          </div>
        </div>

        {groups.map((g) => (
          <div key={g.title} className="col-span-1 md:col-span-2">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-white/65 mb-5">
              {g.title}
            </p>
            <ul className="space-y-3">
              {g.links.map((l) => (
                <li key={l.label}>
                  {l.internal ? (
                    <Link
                      to={l.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-base text-white/85 hover:text-[#a68a6d] transition-colors"
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    >
                      {l.label}
                    </Link>
                  ) : (
                    <a
                      href={l.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-base text-white/85 hover:text-[#a68a6d] transition-colors"
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    >
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="hidden md:block md:col-span-1" />
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-8xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-sm text-white/65">
            © {new Date().getFullYear()} Kubo Payments. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
